import { VhcRecordLogService } from 'api/generated';
import { formatErrorMessage, QueryError } from 'features/shared/model';
import { useMutation, UseMutationOptions } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteVhcRecordVideoInput = {
  id: number;
};

export const useDeleteVhcRecordVideoMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsVideos>>,
      QueryError,
      DeleteVhcRecordVideoInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(({ id: id }: DeleteVhcRecordVideoInput) => VhcRecordLogService.deleteVhcRecordsVideos(id), {
    ...options,
    onSuccess: () => {
      toast.success('Successfully deleted!');
    },
    onError: (error: QueryError) => {
      const message = formatErrorMessage(error);
      toast.error(message);
      console.error(message);
    }
  });
